import { render, staticRenderFns } from "./CustomizePage.vue?vue&type=template&id=0962c565&scoped=true"
import script from "./CustomizePage.vue?vue&type=script&lang=js"
export * from "./CustomizePage.vue?vue&type=script&lang=js"
import style0 from "./CustomizePage.vue?vue&type=style&index=0&id=0962c565&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0962c565",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0962c565')) {
      api.createRecord('0962c565', component.options)
    } else {
      api.reload('0962c565', component.options)
    }
    module.hot.accept("./CustomizePage.vue?vue&type=template&id=0962c565&scoped=true", function () {
      api.rerender('0962c565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/CustomizePage.vue"
export default component.exports